import {push} from "react-router-redux";
import {removeAllLabPersistedData} from "../utils/lab_persist";
import * as Blockv from "../MainBv.js"
const DEV_INFO_LOCALSTORAGE_KEY: string = "blockv-devportal-devinfo";

export interface UserInfo {
	firstName: string;
	lastName: string;
	avatarURL: string;
	isActive: boolean;
	id: string;
	isPublisher: boolean;
}

export interface UserInfoToEdit {
	firstName?: string;
	lastName?: string;
	password?: string;
}

export interface AppIdInfo {
	label: string;
	value: string;
}

export interface DevInfo {
	publisherDomain: string;
	appIds: AppIdInfo[];
	selectedAppId: string;
}

interface CurrentUserState {
	isLoggedIn: boolean;
	isVerified: boolean;
	loginStatus: string;
	loginErrorCode: string;
	isLoginErrorModalShowing: boolean;
	registerStatus: string;
	registerErrorCode: string;
	isRegisterErrorModalShowing: boolean;
	verifyStatus: string;
	verifyErrorCode: string;
	isVerifyErrorModalShowing: boolean;
	userInfo: UserInfo;
	devInfo: DevInfo;
	fetchUserInfoStatus: RequestStatus;
	patchUserInfoStatus: RequestStatus;
	patchErrorMessage: string;
	resetTokenStatus: string;
	verifyStatus: string;
	email: string;
}

const INITIAL_CURRENT_USER_STATE: CurrentUserState = {
	isLoggedIn: false,
	isVerified: false,
	loginStatus: "",
	loginErrorCode: "",
	isLoginErrorModalShowing: false,
	registerStatus: "",
	registerErrorCode: "",
	isRegisterErrorModalShowing: false,
	verifyStatus: "",
	verifyErrorCode: "",
	isVerifyErrorModalShowing: false,
	userInfo: undefined,
	devInfo: undefined,
	fetchUserInfoStatus: "",
	patchUserInfoStatus: "",
	patchErrorMessage: "",
	resetTokenStatus: "",

};

const modifyStateOnLoad = (state: CurrentUserState): CurrentUserState => {
	if (typeof window !== "object") {
		return state;
	}

	const devInfoStored: any =
		JSON.parse(localStorage.getItem(DEV_INFO_LOCALSTORAGE_KEY)) || undefined;

	const devInfo =
		devInfoStored === undefined
			? undefined
			: {
			publisherDomain: devInfoStored.publisher_domain,
			appIds: devInfoStored.app_ids.map(appId => ({
				label: appId.label,
				value: appId.value,
			})),
			selectedAppId: devInfoStored.app_ids.length ? devInfoStored.app_ids[0].value : null,
		};

	return {
		...state,
		devInfo,
	};
};

export default (state: CurrentUserState = modifyStateOnLoad(INITIAL_CURRENT_USER_STATE),
				action: any): CurrentUserState => {
	switch (action.type) {

		case "CURRENT_USER/VERIFY/PENDING": {
			return {
				...state,
				verifyStatus: "pending",
			};
		}

		case "CURRENT_USER/VERIFY/SUCCESS": {
			return {
				...state,
				verifyStatus: "success",
			};
		}

		case "CURRENT_USER/VERIFY/FAILURE": {
			return {
				...state,
				verifyStatus: "failure",
				verifyErrorCode: action.data.errorCode,
				isVerifyErrorModalShowing: true,
			};
		}


		case "CURRENT_USER/REGISTER/PENDING": {
			return {
				...state,
				registerStatus: "pending",
			};
		}

		case "CURRENT_USER/REGISTER/SUCCESS": {
			return {
				...state,
				registerStatus: "success",
				isLoggedIn: true,
				userInfo: {
					firstName: action.data.user.first_name || "",
					lastName: action.data.user.last_name || "",
					avatarURL: action.data.user.avatar_uri || "",
					id: action.data.user.id || "",
					isActive: action.data.user.isActive || false,
					isPublisher: action.data.user.isAdmin || false

				},
				email: action.data.email,
			};
		}

		case "CURRENT_USER/REGISTER/FAILURE": {
			return {
				...state,
				registerStatus: "failure",
				registerErrorCode: action.data.errorCode,
				isRegisterErrorModalShowing: true,
			};
		}

		case "CURRENT_USER/LOGIN/PENDING": {
			return {
				...state,
				loginStatus: "pending",
			};
		}

		case "CURRENT_USER/LOGIN/SUCCESS": {
			console.error(action);
			return {
				...state,
				loginStatus: "success",
				isLoggedIn: true,
				devInfo: null,
				userInfo: {
					firstName: action.data.user.firstName || "",
					lastName: action.data.user.lastName || "",
					avatarURL: action.data.user.avatarUri || "",
					id: action.data.user.id || "",
					isActive: action.data.user.activated || false,
					isPublisher: action.data.user.isAdmin || false
				},
				isVerified: action.data.user.activated,
				email: action.data.email
				/*{
				 publisherDomain: action.data.devInfo.publisher_domain,
				 appIds: action.data.devInfo.app_ids.map(({ label, value }) => ({ label, value })),
				 selectedAppId: action.data.devInfo.app_ids.length
				 ? action.data.devInfo.app_ids[0].value
				 : null,
				 }*/,
			};
		}

		case "CURRENT_USER/LOGIN/FAILURE": {
			return {
				...state,
				loginStatus: "failure",
				isLoggedIn: false,
				loginErrorCode: action.data.errorCode,
				isLoginErrorModalShowing: true,
			};
		}

		case "CURRENT_USER/GET_INFO/PENDING": {
			return {
				...state,
				fetchUserInfoStatus: "pending",
			};
		}

		case "CURRENT_USER/GET_INFO/SUCCESS": {
			console.error(action);
			return {
				...state,
				fetchUserInfoStatus: "success",
				isLoggedIn: true,
				isVerified: action.data.user.activated,
				userInfo: {
					firstName: action.data.user.firstName || "",
					lastName: action.data.user.lastName || "",
					avatarURL: action.data.user.avatarUri || "",
					id: action.data.user.id || "",
					isActive: action.data.user.activated || false,
					isPublisher: action.data.user.isAdmin || false
				},
			};
		}

		case "CURRENT_USER/GET_INFO/FAILURE": {
			// todo: error message
			return {
				...state,
				fetchUserInfoStatus: "failure",
			};
		}

		case "CURRENT_USER/LOGGED_OUT": {
			return {
				...state,
				isLoggedIn: false,
				isVerified: false,
				fetchUserInfoStatus: "",
				patchUserInfoStatus: "",
				userInfo: undefined,
				devInfo: undefined,
			};
		}
		case "CURRENT_USER/VERIFY_CLOSE_ERROR_MODAL": {
			return {
				...state,
				isVerifyErrorModalShowing: false,
			};
		}

		case "CURRENT_USER/REGISTER_CLOSE_ERROR_MODAL": {
			return {
				...state,
				isRegisterErrorModalShowing: false,
			};
		}

		case "CURRENT_USER/LOGIN_CLOSE_ERROR_MODAL": {
			return {
				...state,
				isLoginErrorModalShowing: false,
			};
		}

		case "CURRENT_USER/UPDATE_INFO/PENDING": {
			return {
				...state,
				patchUserInfoStatus: "pending",
			};
		}

		case "CURRENT_USER/UPDATE_INFO/SUCCESS": {
			return {
				...state,
				patchUserInfoStatus: "success",
				userInfo: {
					firstName: action.data.user.properties.first_name,
					lastName: action.data.user.properties.last_name,
					avatarURL: action.data.user.properties.avatar_uri || "",
					id: action.data.user.id,
				},
			};
		}

		case "CURRENT_USER/UPDATE_INFO/FAILURE": {
			return {
				...state,
				patchUserInfoStatus: "failure",
				patchErrorMessage: action.data.error.message,
			};
		}

		case "CURRENT_USER/AVATAR_UPDATE/PENDING": {
			return {
				...state,
				patchUserInfoStatus: "pending",
			};
		}

		case "CURRENT_USER/AVATAR_UPDATE/SUCCESS": {
			return {
				...state,
				patchUserInfoStatus: "success",
				userInfo: {
					...state.userInfo,
					avatarURL: action.data.avatarURL,
				},
			};
		}

		case "CURRENT_USER/AVATAR_UPDATE/FAILURE": {
			return {
				...state,
				patchUserInfoStatus: "failure",
			};
		}

		case "CURRENT_USER/LOGIN_RESET_TOKEN/PENDING": {
			return {
				...state,
				resetTokenStatus: "pending",
			};
		}

		case "CURRENT_USER/LOGIN_RESET_TOKEN/SUCCESS": {
			return {
				...state,
				resetTokenStatus: "success",
			};
		}

		case "CURRENT_USER/LOGIN_RESET_TOKEN/FAILURE": {
			return {
				...state,
				resetTokenStatus: "failure",
			};
		}
	}

	return state;
};

// old-style actions

export const login = (email: string, password: string) => async dispatch => {
	await dispatch({type: "CURRENT_USER/LOGIN/PENDING"});

	try {
		const user = await Blockv.instance.UserManager.login(email, "email", password);
		// const devInfoRes = await fetch(process.env.DEVELOPER_INFO_LAMBDA_URL, {
		// 	headers: {
		// 		Authorization: "Bearer " + Blockv.instance.UserManager.getAccessToken(),
		// 	},
		// });
		/*const devInfo = await devInfoRes.json();

		 if (devInfo.status === "failure") {
		 await Blockv.instance.UserManager.logout();
		 return dispatch({
		 type: "CURRENT_USER/LOGIN/FAILURE",
		 data: { errorCode: devInfo.errors[0].code },
		 });
		 }

		 localStorage.setItem(DEV_INFO_LOCALSTORAGE_KEY, JSON.stringify(devInfo.data));*/

		await dispatch({
			type: "CURRENT_USER/LOGIN/SUCCESS", data: {
				user: user,
				email: email
			}
		});

		await getCurrentUser();

		if (!user.activated) {
			await Blockv
				.UserManager.sendTokenVerification(email, "email");

			return dispatch(push("/verify"));
		}

		return dispatch(push("/"));
	} catch (e) {

		let errorCode = "UNEXPECTED_ERROR";

		if (e.code != null) {
			if (e.code == 2032) {
				errorCode = "UNAUTHORIZED";
			}
		}
		dispatch({type: "CURRENT_USER/LOGIN/FAILURE", data: {errorCode}});

		throw e;
	}
};

export const getCurrentUser = () => async dispatch => {
	dispatch({type: "CURRENT_USER/GET_INFO/PENDING"});

	try {
		console.log(Blockv);
		const user = await Blockv.instance.UserManager.getCurrentUser();
		const accessToken = await Blockv.instance.UserManager.getAccessToken();
		const refreshToken = await Blockv.instance.UserManager.getRefreshToken();

		dispatch({
			type: "CURRENT_USER/GET_INFO/SUCCESS",
			data: {
				user,
				accessToken,
				refreshToken,
			},
		});
	} catch (e) {
		console.error("current user get info failure", e);
		dispatch({
			type: "CURRENT_USER/GET_INFO/FAILURE",
			data: {},
		});

		throw e;
	}
};

export const editUser = (userInfoToEdit: UserInfoToEdit) => async dispatch => {
	dispatch({type: "CURRENT_USER/UPDATE_INFO/PENDING"});

	try {
		const user = await Blockv.instance.UserManager.updateUser({
			first_name: userInfoToEdit.firstName,
			last_name: userInfoToEdit.lastName,
			password: userInfoToEdit.password,
		});

		return dispatch({
			type: "CURRENT_USER/UPDATE_INFO/SUCCESS",
			data: {
				user,
			},
		});
	} catch (e) {
		console.error("current user update info failure", e);
		return dispatch({type: "CURRENT_USER/UPDATE_INFO/FAILURE", data: {error: e}});
	}
};

export const setUserAvatar = (avatarImage: File) => dispatch => {
	return new Promise((resolve, reject) => {
		resolve(dispatch({type: "CURRENT_USER/AVATAR_UPDATE/PENDING"}));

		let fd = new FormData();
		fd.append("avatar", avatarImage);

		Blockv.instance.UserManager.uploadAvatar(fd)
			.then(() => {
				return Blockv.instance.UserManager.getCurrentUser();
			})
			.then(user => {
				resolve(
					dispatch({
						type: "CURRENT_USER/AVATAR_UPDATE/SUCCESS",
						data: {
							avatarURL: user.avatarUri,
						},
					})
				);
			})
			.catch(() => {
				resolve(dispatch({type: "CURRENT_USER/AVATAR_UPDATE/FAILURE"}));
			});
	}).catch((error) => {
		console.log(error.message);
	});
};

// new-style actions

export const actions = {
		logout: () => async(dispatch, getState) => {
			const state = currentUserState(getState());
			await Blockv.instance.UserManager.logout();

			localStorage.removeItem(DEV_INFO_LOCALSTORAGE_KEY);
			removeAllLabPersistedData();

			dispatch({type: "LAB/CLOSE"});
			dispatch({
				type: "CURRENT_USER/LOGGED_OUT",
				data: {id: state.userInfo.id},
			});
		},
		register: (email: string, firstName: string, lastName: string, password: string) => async dispatch => {
			dispatch({type: "CURRENT_USER/REGISTER/PENDING"});

			try {
				const user = await Blockv.instance.UserManager.register({
					"first_name": firstName,
					"last_name": lastName,
					"password": password,
					"user_tokens": [
						{
							"token": email,
							"token_type": "email",
						}
					]
				});

				await dispatch({type: "CURRENT_USER/REGISTER/SUCCESS", data: {user: user, email: email}});

				await getCurrentUser();

				return dispatch(push("/verify"));

			} catch (e) {

				let errorCode = "UNEXPECTED_ERROR";

				if (e.code != null) {
					if (e.code == 2571) {
						errorCode = "INVALID_EMAIL";
					} else if (e.code == 521) {
						errorCode = "TOKEN_UNAVAILABLE";
					}
				}
				dispatch({type: "CURRENT_USER/REGISTER/FAILURE", data: {errorCode}});

				throw e
			}

		},
		verify: (email: string, code: string) => async dispatch => {
			dispatch({type: "CURRENT_USER/VERIFY/PENDING"});
			try {
				await Blockv.instance.UserManager.verifyUserToken({
					"token": email,
					"token_type": "email",
					"verify_code": code
				});

				await dispatch({type: "CURRENT_USER/VERIFY/SUCCESS", data: {}});

				await getCurrentUser();

				return dispatch(push("/user/apps"));
			}
			catch (e) {
				let errorCode = "UNEXPECTED_ERROR";

				if (e.code != null) {

				}
				dispatch({type: "CURRENT_USER/VERIFY/FAILURE", data: {errorCode}});

				throw e
			}

		},

		resetVerifcation: (email: string) => async dispatch => {
			dispatch({type: "CURRENT_USER/VERIFY_RESET_TOKEN/PENDING"});
		},
		resetToken: (email: string) => async dispatch => {
			dispatch({type: "CURRENT_USER/LOGIN_RESET_TOKEN/PENDING"});

			try {
				const deleteTokenRes = await fetch(`${process.env.BLOCKV_API_URL}/v1/user/reset_token`, {
					method: "POST",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded",
						"App-Id": Blockv.instance.store.appID,
						Authorization: `Bearer ${Blockv.instance.UserManager.getAccessToken()}`,
					},
					mode: "cors",
					body: JSON.stringify({
						token_type: "email",
						token: email,
					}),
				});

				return dispatch({type: "CURRENT_USER/LOGIN_RESET_TOKEN/SUCCESS"});
			} catch (e) {
				console.error("reset login token failed", e);
				return dispatch({type: "CURRENT_USER/LOGIN_RESET_TOKEN/FAILURE"});
			}
		},
	}
	;

export const closeLoginErrorModal = () => ({type: "CURRENT_USER/LOGIN_CLOSE_ERROR_MODAL"});
export const closeRegisterErrorModal = () => ({type: "CURRENT_USER/REGISTER_CLOSE_ERROR_MODAL"});
export const closeVerifyErrorModal = () => ({type: "CURRENT_USER/VERIFY_CLOSE_ERROR_MODAL"});
// old-style selectors

export const selectIsLoggingIn = state => state.currentUser.loginStatus === "pending";

export const selectUserInfo = state => state.currentUser.userInfo;
export const selectUserFetchStatus = state => state.currentUser.fetchUserInfoStatus;
export const selectUserPatchStatus = state => state.currentUser.patchUserInfoStatus;
export const selectLoginErroModalIsShowing = state =>
	(state.currentUser as CurrentUserState).isLoginErrorModalShowing;
export const selectLoginErrorCode = state => (state.currentUser as CurrentUserState).loginErrorCode;

// helper to get this reducer's state as a typed value
const currentUserState = state => state.currentUser as CurrentUserState;

// new-style selectors
export const selectors = {
	selectVerifyErrorModalIsShowing: state => currentUserState(state).isVerifyErrorModalShowing,
	selectVerifyErrorCode: state => currentUserState(state).verifyErrorCode,
	selectRegisterErrorModalIsShowing: state => currentUserState(state).isRegisterErrorModalShowing,
	selectRegisterErrorCode: state => currentUserState(state).registerErrorCode,
	selectCurrentUserId: state =>
		currentUserState(state).userInfo ? currentUserState(state).userInfo.id : null,
	selectIsLoggedIn: state => state && currentUserState(state).isLoggedIn,
	selectIsRegistering: state => {
		return state.currentUser.registerStatus === "pending"
	},
	selectCurrentUserEmail: state => {
		return currentUserState(state).userInfo ? currentUserState(state).email : null
	},
	selectIsVerifying: state => {
		return state.currentUser.verifyStatus === "pending"
	},
	selectIsVerified: state => {
		return currentUserState(state).isVerified
	},
	selectResetTokenStatus: state => currentUserState(state).resetTokenStatus,
	selectApps: state => (currentUserState(state).devInfo || ({} as DevInfo)).appIds || [],
	selectAppId: state => (currentUserState(state).devInfo || ({} as DevInfo)).selectedAppId || null,
	selectPublisherDomain: state =>
	(currentUserState(state).devInfo || ({} as DevInfo)).publisherDomain || "",
	selectPatchErrorMessage: state => currentUserState(state).patchErrorMessage,
	selectUserInfo: state => currentUserState(state).userInfo,

};



// WEBPACK FOOTER //
// ./src/reducers/current_user.ts